import React from 'react';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    marginLeft: -28,
    marginRight: -28,
    '& .MuiGrid-item': {
      padding: '10px 28px',
    },
  },
}));

const WrapperContainerFields = ({children}) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.content}>
      {children}
    </Grid>
  );
};

export default WrapperContainerFields;
